import React from 'react';
import moment from 'moment';
import { TextInput, CheckBox, DatePicker } from 'hyperdb-utils';
import UserForm from '../../../modules/users/components/Form';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeUser = this.handleChangeUser.bind(this);
  }
  componentDidMount() {
    if (!this.props.objectData.id) {
      this.props.api.customer.setData({ editedUser: {} });
    }
  }
  render() {
    return (
      <fieldset>
        <CheckBox
          label="Active"
          name="active"
          checked={ this.props.objectData.active }
          onChange={ this.handleClickCheckbox.bind(this, 'active') }
        />
        <TextInput
          label="Name *"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
        />
        <TextInput
          label={ `Client ID ${ !this.props.objectData.id ? ' *' : '' }` }
          disabled={ !!this.props.objectData.id }
          name="client_id"
          value={ this.props.objectData.client_id }
          onChange={ this.handleChange.bind(this, 'client_id') }
        />
        <TextInput
          label="Domain name *"
          name="domain_name"
          value={ this.props.objectData.domain_name }
          onChange={ this.handleChange.bind(this, 'domain_name') }
        />
        <DatePicker
          label="Registration date *"
          name="registration_date"
          value={ this.props.objectData.registration_date }
          onChange={ this.handleChangeDate.bind(this, 'registration_date') }
        />
        <DatePicker
          label="Expiry date"
          name="expiry_date"
          value={ this.props.objectData.expiry_date }
          onChange={ this.handleChangeDate.bind(this, 'expiry_date') }
        />
        {
          !this.props.objectData.id
            ? <fieldset>
                <legend>User</legend>
                <UserForm objectData={ this.props.editedUser || {} } noGroup={ true } onChange={ this.handleChangeUser } />
              </fieldset>
            : null
        }
      </fieldset>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.customer.updateEditedObject({ attributeName, value });
  }
  handleClickCheckbox(attributeName) {
    const checked = !this.props.objectData[attributeName];
    this.props.api.customer.updateEditedObject({ attributeName, value: checked });
  }
  handleChangeDate(attributeName, field) {
    const { name, value } = field;
    const date = value ? moment(value).format('YYYY-MM-DD') : null;
    this.handleChange(attributeName, { value: date });
  }
  handleChangeUser(attributeName, field) {
    const editedUser = { ...this.props.editedUser, [attributeName]: field.value };
    this.props.api.customer.setData({ editedUser });
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/frontend/admin/customer/components/Form.jsx